package org.gymly

import org.gymly.navigation.pushWebHash

/**
 * Web: hash `#/portal/...` / `#/admin/...` refleja la pantalla activa.
 * [isPortalExperience] ya no decide la pantalla de login (siempre unificada).
 */
actual fun isPortalExperience(): Boolean = webWantsPortal()

actual fun canSwitchWebExperience(): Boolean = true

actual fun loginUnificado(): Boolean = true

actual fun esAndroid(): Boolean = false

actual fun openWebPortalExperience() {
    pushWebHash("#/portal/home", replace = true)
}

actual fun openWebAdminExperience() {
    pushWebHash("#/admin/dashboard", replace = true)
}

actual fun notifyWebShellReady() {
    val ready = kotlinx.browser.window.asDynamic().gymlyShellReady
    if (ready != null) ready()
}

internal fun webWantsPortal(): Boolean {
    val path = kotlinx.browser.window.location.pathname.trim().trimEnd('/').lowercase()
    if (path.endsWith("/portal")) return true

    val hash = kotlinx.browser.window.location.hash
        .removePrefix("#")
        .trim()
        .trimStart('/')
        .lowercase()
    if (hash == "portal" || hash.startsWith("portal/")) return true

    val search = kotlinx.browser.window.location.search.lowercase()
    if (search.contains("app=portal") || search.contains("experience=portal")) return true

    return false
}
